<template>
  <div class="container-page">
    <div>
      <p class="title-inner">Карточка организации</p>
    </div>
    <template v-if="isAccessAllowed">
      <TabsListInner>
        <TabsDetailInner name="Основная информация" :selected="true">
          <div>
            <div class="col col-lg-4 pb-0">
              <PictureUpload @pictureSelected="pictureSelected" :initialPhoto="item.picture" :readOnly="!canEdit" />
            </div>
            <div class="row">
              <div class="form-group">
                <ComponentInput
                  v-model="item.name"
                  label="Название"
                  required
                  maxLength="250"
                  placeholder="Введите название"
                  mod="filter"
                  disabled
                />
              </div>
              <div class="form-group">
                <ComponentInput
                  v-model="item.nameFull"
                  label="Полное название"
                  required
                  placeholder="Введите полное название"
                  mod="filter"
                  disabled
                />
              </div>
              <div class="form-group">
                <ComponentInput
                  v-model="item.address"
                  label="Адрес"
                  placeholder="Введите адрес организации"
                  :disabled="!canEdit"
                />
              </div>
              <div class="row">
                <div class="form-group col-6">
                  <ComponentInput
                    v-model="item.phone"
                    label="Телефон"
                    placeholder="Введите телефон организации"
                    :disabled="!canEdit"
                  />
                </div>
                <div class="form-group col-6">
                  <ComponentInput
                    v-model="item.email"
                    type="email"
                    label="E-mail"
                    placeholder="Введите адрес электронной почты организации"
                    :disabled="!canEdit"
                  />
                </div>
              </div>
              <div class="form-group">
                <ComponentInput
                  v-model="item.www"
                  type="url"
                  label="URL адрес"
                  placeholder="Введите ссылку на сайт организации"
                  :disabled="!canEdit"
                />
              </div>
              <div class="form-group">
                <ComponentInput
                  v-model="item.schedule"
                  type="textarea"
                  label="Режим работы"
                  placeholder="Введите режим работы организации"
                  :disabled="!canEdit"
                />
              </div>
              <div class="form-group">
                <ComponentInput label="Тип организации" mod="filter" :modelValue="orgTypeName" disabled />
              </div>
            </div>
            <div class="row mt-10">
              <CheckboxInput v-model="item.isActive" label="Запись активна" disabled />
            </div>
          </div>
        </TabsDetailInner>
        <TabsDetailInner name="Дополнительно">
          <div class="row">
            <div class="form-group col-6">
              <ComponentInput
                v-model="item.inn"
                :fixLength="10"
                label="ИНН"
                placeholder="Введите ИНН организации"
                mod="filter"
                disabled
              />
            </div>
            <div class="form-group col-6">
              <ComponentInput
                v-model="item.ogrn"
                :fixLength="13"
                label="ОГРН"
                mod="filter"
                placeholder="Введите ОГРН организации"
                :disabled="!canEdit"
              />
            </div>
          </div>
          <div class="form-group">
            <ComponentInput
              v-model="item.director"
              label="Директор"
              maxLength="255"
              placeholder="Введите ФИО директора организации"
              :disabled="!canEdit"
            />
          </div>
          <div class="form-group">
            <DateComponent
              v-model="item.registrationDate"
              label="Дата регистрации юридического лица"
              :disabled="!canEdit"
            />
          </div>
          <div class="form-group">
            <ComponentInput
              v-model="item.registrationAddress"
              label="Место регистрации юридического лица"
              maxLength="255"
              placeholder="Введите место регистрации юридического лица"
              :disabled="!canEdit"
            />
          </div>
          <div class="form-group">
            <ComponentInput
              v-model="item.authorizedFund"
              label="Уставный фонд, руб."
              type="number"
              :min="0"
              placeholder="Введите размер уставного фонда юридического лица"
              :disabled="!canEdit"
            />
          </div>
          <div class="form-group disabled-select">
            <ComponentInput
              label="Услуги (ОКВЭД)"
              :select2Settings="select2SettingsMulti"
              :select2Options="okved"
              v-model="item.okvedIds"
              multiple
              type="select2"
              :disabled="!canEdit"
            />
            <i
              class="fas fa-search catalog-icon"
              title="Найти в каталоге"
              @click="openCatalog('nsiokved', 'Выбор услуги')"
              v-if="canEdit"
            ></i>
          </div>
        </TabsDetailInner>
      </TabsListInner>
      <div class="mb-16">
        <ButtonComponent class="mr-8" mod="gradient-bg" @click="save" v-if="canEdit"> Сохранить </ButtonComponent>
        <ButtonComponent mod="border" @click="close"> Отмена </ButtonComponent>
      </div>
    </template>
  </div>
  <section v-if="isAccessAllowed">
    <ModalComponent v-model="catalog.open" :width="950" :title="catalog.title" @close="closeCatalog">
      <CatalogSelectorRedesigned
        :selectedIds="catalog.selectedIds"
        :route="catalog.route"
        :multiple="true"
        @select="updateCatalogField"
        @close="closeCatalog"
      />
    </ModalComponent>
  </section>
</template>

<script>
  import ComponentInput from '@/common/components/ComponentInput.vue';
  import ButtonComponent from '@/common/components/redesigned/ButtonComponent.vue';
  import CheckboxInput from '@/common/components/redesigned/CheckboxInput.vue';
  import TabsDetailInner from '@/common/components/TabsDetailInner.vue';
  import TabsListInner from '@/common/components/TabsListInner.vue';
  import Constants from '@/common/constants';
  import security from '@/common/mixins/security';

  import DateComponent from '../../../common/components/DateComponent/DateComponent.vue';
  import PictureUpload from '../../../common/components/PictureUpload.vue';
  import ModalComponent from '../../../components/modals/ModalComponent.vue';
  import CatalogApi from '../../nsi/api/catalog';
  import CatalogSelectorRedesigned from '../../nsi/components/CatalogSelectorRedesigned.vue';
  import API from '../api/organization';

  const PERMISSIONS = {
    view: Constants.Permissions.OrgView,
    edit: Constants.Permissions.OrgEdit,
  };

  export default {
    name: 'OrganizationCard',
    components: {
      CatalogSelectorRedesigned,
      ModalComponent,
      DateComponent,
      PictureUpload,
      ComponentInput,
      ButtonComponent,
      CheckboxInput,
      TabsListInner,
      TabsDetailInner,
    },
    mixins: [security],
    data() {
      return {
        id: this.$route.params.id,
        /**@public
         * Используется в миксине security
         */
        isReadonly: this.$route.params.action === 'view',
        item: {},
        orgTypes: [],
        okved: [],
        select2SettingsMulti: Constants.select2SettingsMultiple,
        catalog: {
          route: 'nsiokved',
          title: '',
          selectedIds: [],
          open: false,
        },
        canEdit: false,
      };
    },
    async created() {
      const isAllowed = await this.checkPermissionAndRedirect(PERMISSIONS.view);
      if (!isAllowed) return;

      this.checkPermission(PERMISSIONS.edit).then((response) => {
        this.canEdit = response.data;
      });
      this.loadDictionaries();
      this.loadCard();
    },
    methods: {
      loadCard() {
        if (Number(this.id) === 0) {
          this.$router.push({ path: '/' });
          return;
        }
        API.find(this.id).then((response) => {
          this.item = response.data;
        });
      },
      loadDictionaries() {
        API.getOrgTypes().then((response) => {
          if (response.data) {
            let orgTypes = response.data;
            if (this.isAdminSection()) {
              orgTypes = orgTypes.filter((x) => x.id !== Constants.organizationType.navigatorParticipant);
            } else {
              orgTypes = orgTypes.filter((x) => x.id === Constants.organizationType.navigatorParticipant);
            }
            this.orgTypes = orgTypes.map((x) => {
              return { text: x.name, id: x.id };
            });
          }
        });
      },
      pictureSelected(data) {
        this.item.picture = data;
      },
      save() {
        API.update(this.item)
          .then(() => {
            Constants.alert.fire('Сохранение', Constants.commonSuccess, 'success');
            this.loadCard();
          })
          .catch((error) => {
            console.error(error?.response?.data);
            Constants.alert.fire('Сохранение', Constants.commonError, 'error');
          });
      },
      close() {
        this.$router.push({
          name: this.isAdminSection() ? 'Organizations' : 'NavOrgs',
        });
      },
      isAdminSection() {
        return this.$route.path.indexOf('admin') > -1;
      },
      openCatalog(route, title) {
        this.catalog.route = route;
        this.catalog.title = title;
        this.catalog.selectedIds = this.item.okvedIds ?? [];
        this.catalog.open = true;
      },
      updateCatalogField(selection) {
        this.closeCatalog();
        this.item.okvedIds = selection;
      },
      closeCatalog() {
        this.catalog.open = false;
      },
    },
    computed: {
      orgTypeName() {
        const found = this.orgTypes.find((x) => x.id === this.item.organizationTypeId);
        return found ? found.text : '';
      },
    },
    watch: {
      'item.okvedIds': {
        handler: function (value) {
          if (!value?.length) return;
          CatalogApi.getListByIds('nsiokved', value).then((response) => {
            const list = response.data.map((x) => ({ id: x.id, text: x.name }));
            list.forEach((item) => {
              if (!this.okved.find((x) => x.id === item.id)) {
                this.okved.push(item);
              }
            });
          });
        },
        deep: true,
      },
    },
  };
</script>

<style lang="scss" scoped></style>
